import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { useDispatch, useSelector } from 'src/store/store';
import Button from 'src/components/buttons/button';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import { useModalTrigger } from 'src/utils/hooks';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { ModalType } from 'src/constants/modalTypes';
import { SupportingMember } from 'src/constants/types';

const ContactAdminsButton = styled(Button)`
  margin-bottom: 10px;
`;

export default function ContactAdmins({ admins, section }: { admins: SupportingMember[], section: Section }) {
  const triggerContactAdminsModal = useModalTrigger(ModalType.ContactAdmins, { admins });
  const { currentUser, currentCommunity } = useSelector(({ context }) => context);
  const dispatch = useDispatch();

  const handleClick = () => {
    trackFootfallEvent(Event.CLICKED, {
      clickType: 'community-contact',
      clickMetadata: { section },
    });
    if (!currentUser) {
      dispatch(showSignupModal({ community: currentCommunity }));
    } else {
      triggerContactAdminsModal();
    }
  };

  return (
    <ContactAdminsButton onClick={handleClick}>{i18n.t('Contact us')}</ContactAdminsButton>
  );
}
